import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import moment from 'moment';

var _require = require('lodash'),
    get = _require.get;

var Issues = /*#__PURE__*/function () {
  function Issues(issue) {
    // defaultsDeep(this, issue);
    this._total = issue.total;
    this._prevTotal = issue.prevTotal;
    this._monthlyDiff = issue.monthlyDiff;
    this._topMeasures = get(issue, 'topMeasures', {});
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */


  _createClass(Issues, [{
    key: 'total',
    get: function get() {
      return this._total;
    }
  }, {
    key: 'prevTotal',
    get: function get() {
      return this._prevTotal;
    }
  }, {
    key: 'monthlyDiff',
    get: function get() {
      return this._monthlyDiff;
    }
  }, {
    key: 'topMeasures',
    get: function get() {
      var _this = this;

      return Object.keys(this._topMeasures).map(function (key) {
        return {
          name: key,
          value: _this._topMeasures[key]
        };
      });
    }
  }]);

  return Issues;
}();

export { Issues as default };